// PINNED REPORTS (owner, 2026-11-04 — docs/decisions.md D-470): the reports a
// person may pin on Analytics → Reporting, and how many.
//
// Both sides read this. The server refuses a pin that names no report and a
// list longer than the limit, so the limit holds whatever a browser sends; the
// app's rail is held to the same ids by `app/mock/tests/reporting-pinned-reports.test.ts`.

/** The most reports one person may pin. */
export const MAX_REPORT_PINS = 5

/**
 * Every report the Reporting rail offers, by its stable id: the bar charts
 * (`app/src/lib/codeCharts.ts`), Over Time (`overTimeCharts.ts`) and Associated
 * Entities (`entityCharts.ts`). A report added to the rail is added here in the
 * same change; one removed stays readable, because a stored pin that names no
 * report is dropped when it is read.
 */
export const REPORT_IDS = [
  'step-invoices', 'step-spend', 'step-days', 'step-handling', 'step-opened', 'step-denials',
  'vendor-invoices', 'vendor-spend', 'vendor-days', 'vendor-handling', 'vendor-opened', 'vendor-denials',
  'company-invoices', 'company-spend', 'company-days', 'company-handling', 'company-opened', 'company-denials',
  'accounts-spend', 'accounts-vendors', 'departments-spend', 'departments-vendors',
  'line-items-spend', 'line-items-vendor', 'accounts-line-items', 'departments-line-items', 'line-items-vehicle',
  'codes-spend', 'entities-spend',
  'corrections-vendor', 'corrections-field',
  'flags-vendor', 'flags-median-week', 'flags-type', 'flags-needed-correction',
  'holds-vendor', 'holds-step',
  'over-time-invoices-month', 'over-time-invoices-week', 'over-time-invoices-day',
  'over-time-spend-month', 'over-time-spend-week', 'over-time-spend-day',
  'over-time-handling-month', 'over-time-handling-week', 'over-time-handling-day',
  'over-time-flags-month', 'over-time-flags-week', 'over-time-flags-day',
  'over-time-corrections-month', 'over-time-corrections-week', 'over-time-corrections-day',
  'over-time-exports-month', 'over-time-exports-week', 'over-time-exports-day',
  'entities-vehicle-location-spend', 'entities-vehicle-spend', 'entities-tag-exceptions',
] as const

const KNOWN: ReadonlySet<string> = new Set(REPORT_IDS)

/** Whether an id names a report a person may pin. */
export function isReportId(id: string): boolean {
  return KNOWN.has(id)
}
